import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CpApprovalConsultRequestModel } from '../../helpers/objects/request/approval-consult/cp-approval-consult-request-model';
import { map, Observable } from 'rxjs';
import { CpApprovalConsultResponseModel } from '../../helpers/objects/response/approval-consult/cp-approval-consult-response-model';
import { CpBookAppointmentRequestModel } from '../../helpers/objects/request/book-appointment/cp-book-appointment-request-model';
import { CpBookAppointmentResponseModel } from '../../helpers/objects/response/book-appointment/cp-book-appointment-response-model';
import { CpAppointmentsResponseModel } from '../../helpers/objects/response/appointments/cp-appointments-response-model';
import { CpAppointmentsRequestModel } from '../../helpers/objects/request/appointments/cp-appointments-request-model';
import { PaginationModel } from '@fh-client-interaction-frontends/fh-providers';
import { CpAppointmentsModel } from '../../helpers/objects/dto/appointments/cp-appointments-model';
import { CpAppointmentsDetailsModel } from '../../helpers/objects/dto/appointments-details/cp-appointments-details-model';

@Injectable({
  providedIn: 'root'
})
export class CpAppointmentsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  getAll(request: CpAppointmentsRequestModel): Observable<CpAppointmentsResponseModel> {
    const contract = atob(sessionStorage.getItem('contract')!);

    const params = new HttpParams({
      fromObject: request as any
    });

    return this.http.get<any>(this.appConfig.api + 'appointments/' + encodeURIComponent(contract), { params }).pipe(
      map((response) => {
        // Criar uma instância do modelo de resposta
        const responseModel = new CpAppointmentsResponseModel({
          pagination: new PaginationModel(response.body.pagination),
          appointmentList: response.body.appointmentList.map((item: any) => new CpAppointmentsModel(item))
        });

        return responseModel;
      })
    );
  }
  getById(id: string): Observable<CpAppointmentsDetailsModel> {
    const contract = atob(sessionStorage.getItem('contract')!);

    return this.http
      .get<any>(this.appConfig.api + 'appointments/' + encodeURIComponent(contract) + '/' + id)
      .pipe(map((response) => response.body as CpAppointmentsDetailsModel));
  }

  setApproval(body: CpApprovalConsultRequestModel): Observable<CpApprovalConsultResponseModel> {
    const contract = atob(sessionStorage.getItem('contract')!);

    if (body.buildingId) {
      const buildingId = body.buildingId.buildingId;
      body.buildingId = buildingId;
    }

    Object.keys(body).forEach((key) => {
      if (body[key] === null || body[key] === undefined || body[key] === '' || body[key].length == 0) {
        delete body[key];
      }
    });

    return this.http.post<any>(this.appConfig.api + 'appointments/' + encodeURIComponent(contract) + '/approval', body).pipe(
      map((response) => response.body as CpApprovalConsultResponseModel),
      map((response) => {
        switch (response.appointmentStatus.toLowerCase()) {
          case 'new':
            response.appointmentStatus = 'pending';
            break;
          case 'approved':
          case 'accepted':
            response.appointmentStatus = 'approved';
            break;
          case 'canceled':
          case 'refused':
            response.appointmentStatus = 'refused';
            break;
        }
        return new CpApprovalConsultResponseModel(response);
      })
    );
  }

  setBooking(body: CpBookAppointmentRequestModel) {
    const contract = atob(sessionStorage.getItem('contract')!);

    const transformedBody = {
      specialty: body.specialtyId,
      phone: body.mobileNumber,
      service: body.serviceId,
      subService: body.subserviceId,
      contact: {
        provider: body.preferredProvider,
        patient: body.patient
      },
      observations: {
        email: body.email,
        local: body.cityName,
        zone: body.regionName,
        provider: body.preferredProvider,
        date: body.appointmentDate,
        preferentialPeriod: body.preferenceHoursDescription ? this.formatPreferentialPeriod(body.preferenceHoursDescription) : undefined,
        weekDays: body.preferenceWeekDaysDescription ? this.formatWeekDays(body.preferenceWeekDaysDescription) : undefined,
        appointmentMotive: body.appointmentMotive || undefined,
        isPrescription: body.isPrescription || undefined,
        examDescription: body.isPrescription || undefined,
        nationalId: body.nationalId || undefined,
        nationalIdValidity: body.nationalIdValidity || undefined,
        nationalPatientId: body.nationalPatientId || undefined
      },
      cardNumber: body.cardNumber,
      district: body.districtId,
      municipal: body.countyId,
      country_id: body.countryId
    };

    return this.http
      .post<any>(this.appConfig.api + 'appointments/' + encodeURIComponent(contract), transformedBody)
      .pipe(map((response) => response.body as CpBookAppointmentResponseModel));
  }

  private formatPreferentialPeriod(preferenceHours: string[]): string {
    const periodMap = {
      '8h-12h': 'Manhã (8h-12h)',
      '12h-14h': 'Almoço (12h-14h)',
      '14h-18h': 'Tarde (14h-18h)',
      '18h-22h': 'Noite (18h-22h)'
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return preferenceHours.map((hour) => periodMap[hour] || hour).join(', ');
  }
  private formatWeekDays(preferenceDays: string[]): string {
    const dayMap = {
      monday: '2ª Feira',
      tuesday: '3ª Feira',
      wednesday: '4ª Feira',
      thursday: '5ª Feira',
      friday: '6ª Feira',
      saturday: 'Sábado',
      sunday: 'Domingo'
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return preferenceDays.map((day) => dayMap[day] || day).join(', ');
  }
}
